import _ from 'underscore';
import AdExtensionEditor from '@bingads-webui-campaign-legacy/adextension-shared/view/extension-editor';
import AddressView from '@bingads-webui-component-legacy/address/view/index';
import StoreHourView from '@bingads-webui-campaign-legacy/adextension-shared/view/store-hour';
import config from '@bingads-webui-component-legacy/config/index';

const schema = window.globalLegacySchema.get('LocationAdExtension');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');

export default class LocationAdExtensionEditor extends AdExtensionEditor {
  initialize({
    extension = {},
    data,
  } = {}) {
    this.addressView = new AddressView({
      model: extension ? extension.Address : null,
      market: config.get('market') || 'US',
      culture: config.get('culture') && 'en-US',
    });

    this.storeHourView = null;

    if (extension) {
      const storeHourAttributes = ['SundayHours', 'MondayHours', 'TuesdayHours', 'WednesdayHours', 'ThursdayHours', 'FridayHours', 'SaturdayHours', 'SpecialHours'];
      const storeHourModel = [];

      for (let i = 0; i < storeHourAttributes.length; i++) {
        if (extension[storeHourAttributes[i]]) {
          storeHourModel.push({
            key: i18n.getString(`AdExtensions_LocationExtensions_${storeHourAttributes[i]}`),
            value: extension[storeHourAttributes[i]].replace(/,\s/g, '\n').replace(/:\sx/g, ''),
          });
        }
      }

      this.storeHourView = new StoreHourView({
        model: storeHourModel,
      });
    }

    this.addressView.ko_model.errors.subscribe((errors) => {
      this.setErrors({
        $overall: errors,
      });
    });

    super.initialize({
      extension,
      schema,
      data,
      fields: [{
        property: 'CompanyName',
        placeholder: i18n.get('AdExtensions_Location_Placeholder_Name'),
        showHint: true,
      }, {
        property: 'PhoneNumber',
        placeholder: i18n.get('AdExtensions_Location_Placeholder_PhoneNumber'),
        showHint: true,
      }],
    });
  }

  render() {
    super.render();

    this.addressView.render();
    this.$('.extension-editor__extra').append(this.addressView.$el);

    if (this.storeHourView) {
      this.storeHourView.render();
      this.storeHourView.$el.insertBefore(this.$('.alert-info'));
    }


    return this;
  }

  remove() {
    this.addressView.remove();
    super.remove();
  }

  validate() {
    return _.every([this.addressView.validate(), super.validate()]);
  }

  currentModel() {
    const baseModel = super.currentModel();

    baseModel.Address = this.addressView.toObject();

    return baseModel;
  }
}
